import { render, staticRenderFns } from "./BusinessActivityCategory.vue?vue&type=template&id=19cbbf0b&scoped=true"
import script from "./BusinessActivityCategory.vue?vue&type=script&lang=js"
export * from "./BusinessActivityCategory.vue?vue&type=script&lang=js"
import style0 from "./BusinessActivityCategory.vue?vue&type=style&index=0&id=19cbbf0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cbbf0b",
  null
  
)

export default component.exports